<template>
  <b-modal ref="mdlPazienteAttivitaObiettivi" size="xl" style="height: 100%" :okDisabled="null" :title="jsonData.id ? 'Modifica Obiettivo' : 'Crea Obiettivo'" @ok="onOk" @shown="onShown" @hide="onHide">
    <b-row>
      <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
        <label class="sa-label-data">Attivita</label>
        <b-form-select v-model="jsonData.idAttivita" :options="attivitaOptions" text-field="nomeAttivita" value-field="id">
          <template #first>
            <b-form-select-option :value="null" disabled>Seleziona</b-form-select-option>
          </template>
        </b-form-select>
      </b-col>
      <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
        <label class="sa-label-data">Data Inizio</label>
        <date-picker format="DD/MM/YYYY" value-type="timestamp" v-model="jsonData.dataInizio" @input="calcolaPeriodo" type="date"></date-picker>
      </b-col>
      <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
        <label class="sa-label-data">Data Fine</label>
        <date-picker format="DD/MM/YYYY" value-type="timestamp" v-model="jsonData.dataFine" @input="calcolaPeriodo" type="date"></date-picker>
      </b-col>
      <b-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
        <label class="sa-label-data">Obiettivo</label>
        <b-form-input v-model="jsonData.obiettivo" type="number" min="0"> </b-form-input>
      </b-col>
      <b-col cols="12" xs="12" sm="12" md="1" lg="1" xl="1">
        <label class="sa-label-data">Periodo</label>
        <b-form-input v-model="jsonData.periodo" type="number" min="0" :disabled="true"> </b-form-input>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
export default {
  mixin: [UtilityMixin],
  components: { DatePicker },
  data() {
    return {
      pathResourceAttivitaRsa: "/rsaattivita",
      pathResource: "/rsaattivitapazienteobiettivo",

      attivitaOptions: [],
      jsonData: {
        idAccettazione: null,
        idAttivita: null,
        obiettivo: 0,
        periodo: 0,
        dataInizio: new Date().getTime(),
        dataFine: new Date().getTime(),
      },
    };
  },
  mounted() {
    this.jsonData.idAccettazione = this.$route.query.idAccettazione;
    this.onLoadAttivitaRsa();
  },
  methods: {
    onShown() {},
    onHide() {},
    onLoadAttivitaRsa() {
      let me = this;
      UtilityMixin.methods.loadDataResources(me.pathResourceAttivitaRsa, {}, me.loadDataSuccess, me.loadDataError);
    },
    loadDataSuccess(response) {
      let me = this;
      me.attivitaOptions = response.data.data.list;
    },
    loadDataError(error) {
      error;
    },
    resetJsonData() {
      this.jsonData = {
        idAccettazione: this.$route.query.idAccettazione,
        idAttivita: null,
        obiettivo: 0,
        periodo: 0,
        dataInizio: new Date().getTime(),
        dataFine: new Date().getTime(),
      };
    },
    onOk(evt) {
      let validation = this.validazione();
      if (!validation.esito) {
        this.generaBtoast(validation);
        evt.preventDefault();
        return;
      }
      this.jsonData.primaryKey ? this.onModificaObiettivo() : this.onSalvaObiettivo();
    },
    calcolaPeriodo() {
      const differenzaMs = this.jsonData.dataFine - this.jsonData.dataInizio;
      const millisecondiAlGiorno = 1000 * 60 * 60 * 24;
      this.jsonData.periodo = Math.floor(differenzaMs / millisecondiAlGiorno) + 1;
    },
    onModificaObiettivo() {
      let me = this;
      UtilityMixin.methods.restCallPut(process.env.VUE_APP_PATH_API + me.pathResource + "/" + me.jsonData.id, me.jsonData, me.onModificaObiettivoSuccess, me.onModificaObiettivoError);
    },
    onModificaObiettivoSuccess(response) {
      response;
      this.$emit("reload");
    },
    onModificaObiettivoError(erro) {
      erro;
    },
    onSalvaObiettivo() {
      let me = this;
      UtilityMixin.methods.restCallPost(process.env.VUE_APP_PATH_API + me.pathResource, me.jsonData, me.onSalvaObiettivoSuccess, me.onSalvaObiettivoError);
    },
    onSalvaObiettivoSuccess(response) {
      response;
      this.$emit("reload");
    },
    onSalvaObiettivoError(erro) {
      erro;
    },
    validazione() {
      let esito = true;
      let msg = "";

      if (this.jsonData.idAttivita == null || this.jsonData.idAttivita.trim() == "") {
        msg += "Attivita non valida ! #";
        esito = false;
      }

      if (this.jsonData.obiettivo == 0) {
        msg += "obiettivo non valido ! #";
        esito = false;
      }

      return { esito: esito, msg: msg };
    },

    show(obj = null) {
      if (obj != null) {
        this.jsonData = obj;
      } else {
        this.resetJsonData();
      }
      this.$refs.mdlPazienteAttivitaObiettivi.show();
    },
    hide() {
      this.$refs.mdlPazienteAttivitaObiettivi.hide();
    },
  },
};
</script>

<style lang="scss" scoped></style>
